import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ChatInterface from './ChatInterface';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);

  // 🛑 SAFETY CHECK:
  // If this button is somehow loaded inside the widget iframe (nested),
  // DO NOT render it. This prevents the "Recursive Widget" bug.
  if (typeof window !== 'undefined' && window.self !== window.top) {
    return null;
  }

  const toggleChat = () => setIsOpen(!isOpen);

  const buttonBaseClasses = 'fixed z-[999998] rounded-full text-white shadow-lg flex items-center justify-center text-center transition-all duration-300';
  const hoverClasses = 'hover:scale-105';

  // Matches the positioning/size logic of the WP script where possible for consistency
  // Updated to use #ea580c (Orange) gradients
  const closedButtonState = `
    bg-gradient-to-tr from-[#ea580c] to-[#c2410c] shadow-[#ea580c]/30
    w-[60px] h-[60px] md:w-[130px] md:h-[50px]
    bottom-2.5 right-2.5 md:bottom-5 md:right-5
  `;

  const openButtonState = `
    bg-gradient-to-tr from-gray-500 to-gray-700 shadow-gray-500/30
    w-[60px] h-[60px]
    bottom-2.5 right-2.5 md:bottom-5 md:right-5
  `;

  return (
    <>
      {/* Chat Toggle Button */}
      <motion.button
        onClick={toggleChat}
        className={`${buttonBaseClasses} ${hoverClasses} ${isOpen ? openButtonState : closedButtonState}`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label={isOpen ? 'Close chat' : 'Open chat'}
        layout
        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      >
        <AnimatePresence mode="wait">
          {isOpen ? (
            <motion.span
              key="close"
              initial={{ opacity: 0, rotate: -90 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: 90 }}
              className="text-2xl font-light"
            >
              ✕
            </motion.span>
          ) : (
            <motion.div
              key="open"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5 }}
              className="flex items-center justify-center w-full h-full"
            >
              <span className="hidden md:block text-base font-semibold leading-tight normal-case whitespace-nowrap px-1">
                Questions
              </span>
              <span className="block md:hidden text-3xl font-bold">?</span>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.button>

      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && (
          <ChatInterface onClose={toggleChat} showCloseButton={false} />
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatBot;